export default __webpack_public_path__ + "static/media/hourglass.da1859a3.svg";